import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useController,
  useFieldArray,
  useForm,
  useWatch,
} from "react-hook-form";
import toast from "react-hot-toast";
import moment from "moment";

import {
  addRec,
  cancelEditing,
  deleteRec,
  editRec,
  fetchListing,
  getById,
  info,
} from "../../services";
import { messageText } from "../../store/actions";
import {
  filterActiveData,
  getSumOfArrayOfObjects,
  toastDisplay,
} from "../../_helpers/utilities";
import SearchableSelect from "../Master/searchableSelect";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import SelectCustomerModal from "../Customer/SelectCustomerModal";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { MdDragHandle } from "react-icons/md";
import { Tooltip } from "react-tooltip";
import UploadFile from "../uploadfile/UploadFile";
import { isArray } from "lodash";
import { ButtonLoader, Loader } from "../Loader";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import logo from "../../_assets/images/pdflogo.png";

export default function AmendmentView() {
  const backToTopRef = React.useRef(null);

  const mainContainer = React.useRef(null);

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { message, msgType } = useSelector((state) => state.common);

  const formCtx = useForm({
    defaultValues: {
      documentDate: moment(new Date()).format("YYYY-MM-DD"),
      oaNo: "",
      masterBranchId: "",
      masterSalesOfficeId: "",
      masterBackupTypeId: "",
      // amendmentAttachmentList: [],
      attachments: [],
      attachmentsDetail: [],
      MasterAttachmentType: [],
      MasterSubAttachmentType: [],
      isActive: true,
      date: moment(new Date()).format("YYYY-MM-DD"),
      zipArray: [],
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
    reset,
    watch,
    clearErrors,
  } = formCtx;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "details",
  });

  const MasterAttachmentVal = useWatch({
    control,
    name: "MasterAttachmentType",
  });

  const MasterSubAttachmentVal = useWatch({
    control,
    name: "MasterSubAttachmentType",
  });

  const oldAttachmentsVal = useWatch({
    control,
    name: "oldAttachments",
  });

  const addRow = () => {
    if (fields.length < 5) {
      // append({});
    }
  };
  // const {
  //   field: { name, ref },
  // } = useController({ name: "amendmentAttachmentList", control });

  let serialNo = 0;

  const [branchArr, setBranchArr] = useState([]);
  const [salesOfficeArr, setSalesOfficeArr] = useState([]);
  const [backupTypeArr, setBackupTypeArr] = useState([]);
  const [amendmentTypeArr, setAmendmentTypeArr] = useState([]);
  const [amendmentDetailArr, setAmendmentDetailArr] = useState([]);
  const [customerArr, setCustomerArr] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [uploadedtabledata, setuploadedtabledata] = useState([]);

  const [loader, setLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [lockInput, setLockInput] = useState(false);

  const detailsArr = watch("details");

  useEffect(() => {
    if (location?.state?.editId) {
      setIsEdit(true);
      setLoader(true);
      setEditId(location?.state?.editId);
      if (location?.state?.isViewOnly) {
        setLockInput(true);
      }
    }
  }, [location?.state?.editId]);

  const BranchList = async () => {
    let data = await fetchListing("/MasterBranch/getalls");
    if (data?.status === 200) {
      setBranchArr(filterActiveData(data?.data));
      SalesOfficeList();
    } else {
      SalesOfficeList();
    }
  };

  const CustomerList = async (id) => {

    let data = await info(`/MasterCustomer/${id}`);
    //console.log(data)
    //let data = await fetchListing("/MasterCustomer/getalls");
    if (data?.status === 200) {
      // console.log(data?.data)
      let custarrnew = [];
      custarrnew.push(data?.data)
      if (custarrnew?.length > 0) {


        setCustomerArr(custarrnew);
        //transporterList();
      } else {
        setCustomerArr([]);
        //transporterList();
      }
    }
  };

  const SalesOfficeList = async () => {
    let data = await fetchListing("/MasterSalesOffice/getalls");
    if (data?.status === 200) {
      let addName = data?.data.map((item) => {
        let sapcode = item?.sapCode ? " (" + item?.sapCode + ")" : "";
        return { ...item, name: item.name + sapcode };
      });
      setSalesOfficeArr(filterActiveData(addName));
      BackupTypeList();
    } else {
      BackupTypeList();
    }
  };

  const BackupTypeList = async () => {
    let data = await fetchListing("/MasterBackupType/getalls");
    if (data?.status === 200) {
      let backupType = data?.data.map((item) => {
        let shortName = item?.shortName ? " (" + item?.shortName + ")" : "";
        return { ...item, name: item.type + shortName };
      });
      setBackupTypeArr(filterActiveData(backupType));
      AmendmentTypeList();
    } else {
      AmendmentTypeList();
    }
  };

  const AmendmentTypeList = async () => {
    let data = await fetchListing("/MasterAmendmentType/getalls");
    if (data?.status === 200) {
      let amendmentDetailType = data?.data.map((item) => {
        let shortName = item?.shortName ? " (" + item?.shortName + ")" : "";
        return ({
          ...item,
          name: item.type + shortName,
        })
      });
      setAmendmentTypeArr(filterActiveData(amendmentDetailType));
      AmendmentDetailList();
    } else {
      AmendmentDetailList();
    }
  };

  const AmendmentDetailList = async () => {
    let data = await fetchListing("/MasterAmendmentTypeDetail/getalls");
    if (data?.status === 200) {
      let amendmentDetailType = data?.data.map((item) => {
        let shortName = item?.shortName ? " (" + item?.shortName + ")" : "";
        return {
          ...item,
          name: item.type + shortName,
        };
      });
      setAmendmentDetailArr(filterActiveData(amendmentDetailType));
      AttachmentTypeList();
    } else {
      AttachmentTypeList();
    }
  };

  const AttachmentTypeList = async () => {
    let data = await fetchListing("/MasterAttachmentType/getalls");
    if (data?.status === 200) {
      var attachType = data?.data.map((obj) => ({ ...obj, name: obj.type }));
      setValue("MasterAttachmentType", attachType);
      SubAttachmentTypeList();
    } else {
      SubAttachmentTypeList();
    }
  };

  const SubAttachmentTypeList = async () => {
    let data = await fetchListing("/MasterSubAttachmentType/getalls");
    if (data?.status === 200) {
      var attachType = data?.data.map((obj) => ({ ...obj, name: obj.type }));
      setValue("MasterSubAttachmentType", attachType);
      if (location?.state?.editId) {
        getInfo(location?.state?.editId);
      }
    } else {
      if (location?.state?.editId) {
        getInfo(location?.state?.editId);
      }
    }
  };

  useEffect(() => {
    BranchList();
  }, []);


  const backToHome = async () => {
    if (isEdit) {
      let data = await cancelEditing(`/Amendment/cancelEditing/${editId}`);
      if (data?.status === 200) {
        history.push("/amendment");
      } else {
        toast.success(data?.message);
      }
    } else {
      history.push("/amendment");
    }
  };

  const handleDragEnd = (results) => {
    if (!results.destination) return;
    let tempUser = [...detailsArr];
    let [selectedRow] = tempUser.splice(results.source.index, 1);
    tempUser.splice(results.destination.index, 0, selectedRow);
    setValue("details", tempUser);
  };

  const [openCustModal, setOpenCustModal] = useState(false);
  const openModalFunc = () => {
    setOpenCustModal(true);
  };
  const closeModalFunc = () => {
    setOpenCustModal(false);
  };

  const [openContactModal, setOpenContactModal] = useState(false);
  const openContactModalFunc = () => {
    setOpenContactModal(true);
  };
  const closeContactModalFunc = () => {
    setOpenContactModal(false);
  };

  const [openDIBModal, setOpenDIBModal] = useState(false);
  const openDIBModalFunc = () => {
    setOpenDIBModal(true);
  };
  const closeDIBModalFunc = () => {
    setOpenDIBModal(false);
  };


  const getInfo = async (id) => {
    let data = await info(`/Amendment/${id}`);
    if (data?.status === 200) {
      setValue(
        "documentDate",
        moment(data?.data?.documentDate).format("YYYY-MM-DD")
      );

      setValue("oaNo", data?.data?.oaNo);
      setValue("DocumentNo", data?.data?.documentNo);
      setValue("masterBranchId", data?.data?.masterBranchId);

      setValue("masterSalesOfficeId", data?.data?.masterSalesOfficeId);
      setValue("masterBackupTypeId", data?.data?.masterBackupTypeId);
      CustomerList(data?.data?.masterCustomerId)
      setValue("masterCustomerId", data?.data?.masterCustomerId);
      setValue("customerAddress", data?.data?.customerAddress);
      setValue("amendmentAttachmentList", data?.data?.amendmentAttachmentList);
      // setValue("messageId", data?.data?.messageId);
      setValue("oldAttachments", data?.data?.attachments);

      if (data?.data?.details) {
        if (data?.data?.details.length > 0) {
          let filter = data?.data?.details?.map((item, index) => {
            return {
              ...item,
              detailsID: item?.id ? item?.id : "",
              all: item.lineItemNo > 0 ? false : true,
            };
          });
          setValue("details", filter);
        } else {
          setValue("details", []);
        }
      }

      setValue(
        "isActive",
        data?.data?.isActive ? data?.data?.isActive : "true"
      );
    }
    setLoader(false);
  };
  const handleAttachmentDataFunc = (tableData) => {
    setuploadedtabledata(tableData);
  };
  const attachmentsDetailArrFunc = (data) => {
    // console.log({data})
    setValue("attachmentsDetail", data);
  };
  const attachmentsFunc = (data) => {
    setValue("attachmentFile", data);
    setValue("attachments", data);
  };

  const removeOldFile = (data) => {
    let FilteredOldAttachments = oldAttachmentsVal.filter(
      (obj) => obj.id !== data.attachmentId
    );
    setValue("oldAttachments", FilteredOldAttachments);
  };

  const [printDoc, setPrintDoc] = React.useState(false);
  const titleBox = React.useRef(null);

  const generatePDF = () => {
    const input = mainContainer.current;
    const header = titleBox.current;

    let til = header.querySelector(".comntitle").innerText,
      headUrl = `<span>CHANGE ORDER REQUEST</span> <span className="logo-preview"><img src='${logo}' alt="logo here" width="90" /></span>`;

    header.querySelector(".comntitle").innerHTML = headUrl;

    if (!input) {
      return;
    }

    setPrintDoc(true);

    setTimeout(() => {
      html2canvas(header).then((head) => {
        headUrl = head.toDataURL("image/png");
      });

      html2canvas(input).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("l", "mm", "a4");
        const imgWidth = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let positionY = -15;
        let remainingHeight = imgHeight + 20;

        const spaceHeight = 5;

        while (remainingHeight > 0) {
          pdf.addImage(
            imgData,
            "JPEG",
            0 + spaceHeight,
            -positionY + spaceHeight,
            Math.min(imgWidth, 297) - 2 * spaceHeight,
            imgHeight
          );

          pdf.setFillColor(255, 255, 255);
          pdf.rect(0, 195, 297, 210, "F");
          pdf.rect(0, 0, 297, 12, "F");

          pdf.addImage(
            headUrl,
            "JPEG",
            0 + spaceHeight,
            0 + spaceHeight / 2,
            297 - 2 * spaceHeight,
            13
          );

          console.log(remainingHeight);
          remainingHeight -= 210;
          if (remainingHeight > 0) {
            pdf.addPage("landscape", "a4");
          }
          positionY += 210 - 35;
        }

        let docNo = getValues("DocumentNo");
        pdf.save("CHG - " + docNo + ".pdf");
      });

      header.querySelector(".comntitle").innerHTML = til;

      setTimeout(() => setPrintDoc(false), 300);
    }, 10);
  };

  return loader ? (
    <Loader />
  ) : (
    <div>
      <section class={`mian_part ${printDoc ? "printActive" : ""}`}>
        <div class="titlediv" ref={titleBox}>
          <h1 class="comntitle">Amendment</h1>
        </div>
        <div className="printPage" ref={mainContainer}>
          <form action="">
            <div class="row">
              {isEdit && (
                <div class="col-lg-4 col-md-6">
                  <div class="input-group">
                    <label className="cu_form_label">Doc No</label>
                    <input
                      type="text"
                      id="DocumentNo"
                      name="DocumentNo"
                      disabled
                      placeholder={
                        errors.DocumentNo ? errors.DocumentNo.message : ""
                      }
                      className={errors.DocumentNo ? "error" : ""}
                      {...register("DocumentNo", {
                        // required: "Document No is required.",
                      })}
                    />
                  </div>
                </div>
              )}
              <div class="col-lg-4 col-md-6">
                <div class="input-group">
                  <label className="cu_form_label">Date</label>
                  <input
                    type="date"
                    id="documentDate"
                    name="documentDate"
                    disabled
                    placeholder={
                      errors.documentDate ? errors.documentDate.message : ""
                    }
                    className={errors.documentDate ? "error" : ""}
                    {...register("documentDate", {
                      matches:
                        (/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/,
                          "Date of Birth must be a valid date in the format YYYY-MM-DD"),
                    })}
                  />
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="input-group">
                  <label className="cu_form_label">OA No</label>
                  <input
                    type="text"
                    id="oaNo"
                    name="oaNo"
                    disabled
                    maxLength={7}
                    placeholder={errors.oaNo ? errors.oaNo.message : ""}
                    className={errors.oaNo ? "error" : ""}
                    {...register("oaNo", {
                      // required: "OA no is required",
                    })}
                  />
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="inputcu-field">
                  <label className="cu_form_label">Customer Name</label>
                  <SearchableSelect
                    name="masterCustomerId"
                    optionList={customerArr}
                    errors={errors.masterCustomerId}
                    isDisabled={true}
                    control={control}
                    {...register("masterCustomerId", {
                      // required: "Customer is required.",
                    })}
                  />
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="inputcu-field">
                  <label className="cu_form_label">Branch</label>
                  <SearchableSelect
                    placeholder="Select Branch"
                    name="masterBranchId"
                    optionList={branchArr}
                    errors={errors.masterBranchId}
                    control={control}
                    {...register("masterBranchId", {
                      // required: "Branch is required.",
                      // valueAsNumber: true,
                    })}
                    isDisabled
                  />
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="inputcu-field">
                  <label className="cu_form_label">Sales Office</label>
                  <SearchableSelect
                    placeholder="Select Sales Office"
                    name="masterSalesOfficeId"
                    optionList={salesOfficeArr}
                    errors={errors.masterSalesOfficeId}
                    control={control}
                    {...register("masterSalesOfficeId", {
                      // required: "Sales office is required.",
                      // valueAsNumber: true,
                    })}
                    isDisabled
                  />
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="input-group">
                  <label>Address</label>
                  <input
                    type="text"
                    id="customerAddress"
                    name="customerAddress"
                    placeholder={
                      errors.customerAddress
                        ? errors.customerAddress.message
                        : ""
                    }
                    className={errors.customerAddress ? "error" : ""}
                    {...register("customerAddress", {
                      // required: "address is required",
                    })}
                    disabled
                  />
                </div>
              </div>
              <div class="col-lg-4 col-md-6">
                <div class="inputcu-field">
                  <label className="cu_form_label">Backup Type</label>
                  <SearchableSelect
                    placeholder="Select Backup Type"
                    name="masterBackupTypeId"
                    optionList={backupTypeArr}
                    errors={errors.masterBackupTypeId}
                    control={control}
                    {...register("masterBackupTypeId", {
                      // required: "Backup Type is required.",
                    })}
                    isDisabled
                  />
                </div>
              </div>
            </div>
            {fields && fields.length > 0 && (
              <div class="col-lg-12">
                <div className="comanbox_form custom_gray_bg">
                  <div class="export-btn buttontiel">
                    <h2>Amendment Detail</h2>
                  </div>
                  <div className="comanbox_body">
                    <div className="row">
                      <div className="col-12">
                        <DragDropContext
                          onDragEnd={(results) => handleDragEnd(results)}
                        >
                          <table class="table addField_table mt-3">
                            <thead>
                              <tr>
                                <th scope="col"> Sr No</th>
                                {/* <th scope="col">All</th> */}
                                <th scope="col">Line Item No</th>
                                <th scope="col">Amedent Type</th>
                                <th>Amendment Type Detail</th>
                                <th scope="col">Previous(Before Amedent)</th>
                                <th scope="col">Revised(After Amedent)</th>
                              </tr>
                            </thead>
                            <Droppable droppableId="tbody">
                              {(provided) => (
                                <tbody
                                  ref={provided.innerRef}
                                  {...provided.droppableProps}
                                >
                                  {fields?.map((row, index) => (
                                    <Draggable
                                      draggableId={row.id}
                                      index={index}
                                      key={row.id}
                                    >
                                      {(provided) => (
                                        <tr
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                        >
                                          <td>{++serialNo}</td>
                                          <td className="max_widh_100">
                                            {getValues(
                                              `details.${index}.all`
                                            ) ? (
                                              <span>All</span>
                                            ) : (
                                              <span>
                                                {getValues(
                                                  `details.${index}.lineItemNo`
                                                )}
                                              </span>
                                            )}
                                          </td>

                                          <td>
                                            <span>
                                              {getValues(
                                                `details.${index}.type`
                                              )}
                                              {getValues(
                                                `details.${index}.shortName`
                                              ) &&
                                                `(${getValues(
                                                  `details.${index}.shortName`
                                                )})`}

                                            </span>
                                          </td>
                                          <td>
                                            <span>
                                              {getValues(
                                                `details.${index}.typeDetail`
                                              )}
                                              {getValues(
                                                `details.${index}.typeShortName`
                                              ) &&
                                                `(${getValues(
                                                  `details.${index}.typeShortName`
                                                )})`}
                                            </span>
                                          </td>
                                          <td>
                                            <span>
                                              {getValues(
                                                `details.${index}.previous`
                                              )}
                                            </span>
                                          </td>
                                          <td className=" max_widh_150">
                                            <span>
                                              {getValues(
                                                `details.${index}.revised`
                                              )}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                    </Draggable>
                                  ))}
                                  {provided.placeholder}
                                </tbody>
                              )}
                            </Droppable>
                          </table>
                        </DragDropContext>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div class="attachmenthi">
              <UploadFile
                hideUpload={true}
                formCtx={formCtx}
                oldAttachments={isEdit ? getValues("oldAttachments") : false}
                attachmentData={handleAttachmentDataFunc}
                AttachmentsDetailFunc={attachmentsDetailArrFunc}
                AttachmentFunc={attachmentsFunc}
                zipid={isEdit ? getValues("DocumentNo") : false}
                moduleDetails={isEdit ? `Amendment-${editId}` : false}
                moduleName={`Amendment`}
                editId={editId}
                getLatestAttachment={(id) => getInfo(id)}
                MasterAttachmentVal={MasterAttachmentVal}
                MasterSubAttachmentVal={MasterSubAttachmentVal}
                removeOldFile={removeOldFile}
                isEdit={isEdit}
                ShowZipButton={false}
              // callFunc={callFunc}
              />
            </div>

            <div className="noticeShow">
              <h5 className="notestitle">Special Notes :- </h5>
              <ol className="specialNotes">
                <li className="points">
                  Please write ONLY OA number on the top & Line item number in
                  column "B" (Free Field)
                </li>
                <li className="points">
                  Please attache revised technical sheet or SCE file for
                  technical amendment
                </li>
                <li className="points">
                  In case of change of address, please mention customer no which
                  is availalble in SAP.
                </li>
                <li className="points">
                  In case of amendment from customer, please attached back up
                  from customer
                </li>
                <li className="points">
                  In case of Technical amendment, customer requested date must
                  be LATER than date of amendment. If not mentioned, requested
                  date will be chonsidered as 01 week ahead of amendment date
                </li>
              </ol>
            </div>
          </form>
        </div>
        <div class="col-12">
          <div class="groupbtn">
            {/* <button class="Comnbtn BlackBtn" onClick={() => generatePDF()}>
              Print   {printDoc && <div className="parentLoad"><Loader /></div>}
            </button> */}
            <button class="Comnbtn OutlineRedBtn" onClick={() => backToHome()}>
              Cancel
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
